import React, { useEffect, useState } from "react";

export function PageRecovery({ reload = () => window.location.reload() }) {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => { window.removeEventListener("online", update); window.removeEventListener("offline", update); };
  }, []);
  return <main className="phx-ui mx-auto max-w-lg space-y-4 p-6" data-testid="page-recovery">
    <p className="text-sm font-semibold text-slate-500">PHOENIX ERP</p>
    <h1 className="text-2xl font-semibold text-slate-900">This page couldn’t load</h1>
    <p role="status" className="text-sm leading-6 text-slate-600">{online ? "Please retry the page. If the problem continues, return to the dashboard." : "You’re offline. Reconnect, then retry the page."}</p>
    <p className="text-sm leading-6 text-slate-600">Drafts and pending submissions saved on this device are kept. Retrying this page does not submit a voucher. If a save was interrupted, use its saved submission to confirm the result before entering it again.</p>
    <div className="flex flex-wrap gap-3"><button type="button" className="phx-button phx-button-primary" onClick={reload}>Reload and retry</button><a className="phx-button" href="/app/dashboard">Open dashboard</a></div>
  </main>;
}

export class PageRecoveryBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() { return this.state.failed ? <PageRecovery /> : this.props.children; }
}
